var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v100H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 49c0 24.853-20.147 45-45 45S12 73.853 12 49 32.147 4 57 4s45 20.147 45 45z",
    fill: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: 4,
    width: 109,
    height: 90
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.577 4C82 4 102 24.5 102 49.44c0 24.598-19.891 44.538-44.43 44.538 0 0-15.512 1-29.528-10.497C28.042 93.978-7 93.978-7 93.978V4h64.577z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.244 69.216H78.07c.998 0 1.806-.804 1.802-1.797V15.317a2.45 2.45 0 0 0-2.45-2.45H11.887a2.45 2.45 0 0 0-2.45 2.45v52.102c0 .993.809 1.797 1.807 1.797z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.437 25.729h70.436V14.582c0-.948-.858-1.715-1.916-1.715H11.354c-1.059 0-1.917.767-1.917 1.715v11.147z",
    fill: "#399C97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.936 20.818H16.785c-.766 0-1.385-.555-1.385-1.243 0-.687.619-1.242 1.385-1.242h10.151c.766 0 1.384.555 1.384 1.242 0 .688-.618 1.243-1.384 1.243zM43.885 20.818h-9.761c-.736 0-1.331-.555-1.331-1.243 0-.687.595-1.242 1.331-1.242h9.761c.737 0 1.331.555 1.331 1.242 0 .688-.594 1.243-1.33 1.243zM61.224 20.818H51.072c-.766 0-1.384-.555-1.384-1.243 0-.687.618-1.242 1.384-1.242h10.152c.766 0 1.384.555 1.384 1.242 0 .688-.618 1.243-1.384 1.243z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.349 30.755H17.85a2.45 2.45 0 0 0-2.45 2.45v10.008a2.45 2.45 0 0 0 2.45 2.45H29.35a2.45 2.45 0 0 0 2.45-2.45V33.205a2.45 2.45 0 0 0-2.45-2.45zM29.349 50.632H17.85a2.45 2.45 0 0 0-2.45 2.45V63.09a2.45 2.45 0 0 0 2.45 2.45H29.35a2.45 2.45 0 0 0 2.45-2.45V53.082a2.45 2.45 0 0 0-2.45-2.45z",
    fill: "#5AB2AC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.36 86.978h74.019c1.105 0 2.001-.801 1.996-1.791V33.275a2.45 2.45 0 0 0-2.45-2.45H39.808a2.45 2.45 0 0 0-2.45 2.45v51.912c0 .99.895 1.79 2.001 1.79z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.358 43.745h78.017V32.548c0-.952-.95-1.723-2.123-1.723H39.481c-1.173 0-2.123.771-2.123 1.723v11.197z",
    fill: "#399C97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.375 43.745H37.358v29.816h78.017V43.745z",
    fill: "#7FBEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.53 81.511H44.909c-.878 0-1.587-.665-1.587-1.49s.709-1.49 1.587-1.49H74.53c.878 0 1.587.665 1.587 1.49s-.709 1.49-1.587 1.49z",
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.073 58.376H45.905c-1.155 0-2.088-1-2.088-2.236 0-1.238.933-2.237 2.088-2.237h21.168c1.155 0 2.088 1 2.088 2.236 0 1.238-.933 2.237-2.088 2.237z",
    fill: "#208B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.856 38.777h-10.15c-.767 0-1.385-.555-1.385-1.243 0-.687.618-1.242 1.384-1.242h10.151c.767 0 1.385.555 1.385 1.242 0 .688-.618 1.243-1.385 1.243zM71.805 38.777h-9.761c-.737 0-1.331-.555-1.331-1.243 0-.687.594-1.242 1.33-1.242h9.762c.736 0 1.331.555 1.331 1.242 0 .688-.595 1.243-1.33 1.243zM89.144 38.777H78.993c-.767 0-1.385-.555-1.385-1.243 0-.687.618-1.242 1.385-1.242h10.151c.766 0 1.384.555 1.384 1.242 0 .688-.618 1.243-1.384 1.243z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.39 59.768H74.927v4.828c0 3.82 1.264 6.945 3.659 8.963H92.73c.008-.004.013.005.021 0 2.381-2.005 3.643-5.157 3.643-8.967l-.005-4.824z",
    fill: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.444 64.219c.175 1.943.623 3.859 1.342 5.673l1.436 3.668h7.676l1.436-3.663a20.262 20.262 0 0 0 1.342-5.678H88.444zM101.203 57.763l-2.309-9.545h-7.668l-2.308 9.55a19.46 19.46 0 0 0-.363 1.911h-.004c-.17 1.25-.226 2.512-.17 3.766.012.298.038.476.064.773h13.231c.025-.297.051-.475.064-.773a19.973 19.973 0 0 0-.537-5.682z",
    fill: "#208B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79 69.892a20.19 20.19 0 0 1-1.341-5.669H74.928v.373c0 3.82 1.264 6.945 3.659 8.963H92.73c.008-.004.013.005.021 0h-1.53l-1.43-3.667z",
    fill: "#208B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.393 64.592v-.373h-7.949a20.26 20.26 0 0 0 1.342 5.668l1.436 3.668h1.53c2.38-2.005 3.641-5.152 3.641-8.963z",
    fill: "#02614E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38 63.343c-.055-1.219 0-2.361.175-3.575H74.928v4.45h13.517a29.634 29.634 0 0 1-.064-.876z",
    fill: "#208B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38 63.343c.013.289.034.588.06.877l7.95.002v-4.454h-7.84c-.17 1.214-.225 2.356-.17 3.575z",
    fill: "#02614E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: -2.098,
    y: 3.639,
    width: 93.507,
    height: 79.419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.307
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.768
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 25.823,
    y: 21.597,
    width: 101.087,
    height: 79.223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.307
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.768
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v100H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.57635129fb372dd053f94b5f9f2e1d38.svg";
export { ForwardRef as ReactComponent };